import { createContext } from 'react';
import { Guild } from '../types';

type GuildContextType = {
  guild?: Guild;
  updateGuild: (guild: Guild) => void;
};

export const GuildContext = createContext<GuildContextType>({
  updateGuild: () => {},
});